export default __webpack_public_path__ + "static/media/v3.53a143cb.jpg";